// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'
import { FILE_LOADED } from '../constants/ActionTypes'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').HistoryEntry} HistoryEntry
 * @typedef {import('../types/system').Undo} Undo
 */

/**
 * @type {function(PlottrState): Undo}
 */
export const undoSelector = createSelector(fullSystemStateSelector, ({ undo }) => {
  return (
    undo ?? {
      history: [],
      future: [],
    }
  )
})
/**
 * @type {function(PlottrState): number}
 */
export const undoGenerationSelector = createSelector(undoSelector, ({ generation }) => {
  return generation
})
/**
 * @type {function(PlottrState): Array<HistoryEntry>}
 */
export const undoHistorySelector = createSelector(undoSelector, ({ history }) => {
  return history ?? []
})
/**
 * @type {function(PlottrState): (HistoryEntry | Null)}
 */
export const lastUndoStateSelector = createSelector(undoHistorySelector, (history) => {
  return history?.[0] ?? null
})
/**
 * @type {function(PlottrState): Array<HistoryEntry>}
 */
export const undoFutureSelector = createSelector(undoSelector, ({ future }) => {
  return future ?? []
})
/**
 * @type {function(PlottrState): (HistoryEntry | Null)}
 */
export const lastRedoStateSelector = createSelector(undoFutureSelector, (future) => {
  return future?.[0] ?? null
})
/**
 * @type {function(PlottrState): boolean}
 */
export const recentlyUndidOrRedidSelector = createSelector(
  undoSelector,
  ({ recentlyUndidOrRedid }) => {
    return recentlyUndidOrRedid
  }
)
/**
 * @type {function(PlottrState): Array<String>}
 */
export const historyLabelsSelector = createSelector(undoHistorySelector, (history) => {
  return history
    .filter(({ actionType }) => {
      return actionType !== FILE_LOADED
    })
    .map(({ actionLabel }) => {
      return actionLabel ?? 'Unknown'
    })
})
/**
 * @type {function(PlottrState): Array<String>}
 */
export const futureLabelsSelector = createSelector(undoFutureSelector, (future) => {
  return future.map(({ actionLabel }) => {
    return actionLabel ?? 'Unknown'
  })
})
/**
 * @type {function(PlottrState): number}
 */
export const undoRedoChangeIdSelector = createSelector(undoSelector, ({ changeId }) => {
  return changeId
})
/**
 * @type {function(PlottrState): boolean}
 */
export const showUndoRedoSelector = createSelector(undoSelector, ({ showUndoRedo }) => {
  return showUndoRedo
})
